<div class="animate-pulse w-full h-full">
  @if (kind() === 'text') {
  <div
    class="rounded-md w-full mb-2 bg-slate-200"
    [ngClass]="[size ? size : 'h-3']"
  ></div>
  } @if (kind() === 'image') {
  <div
    class="bg-slate-200 mb-2 rounded-[10px]"
    [ngClass]="[size ? size : 'h-14 w-14']"
  ></div>
  }
</div>
